import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { removeScrollbar } from '@/styles/helpers';

export const BreadcrumbsBox = styled.div<{
  $hasHorizontalPadding?: boolean;
  $hasBg?: boolean;
  $isHidden?: boolean;
}>`
  ${removeScrollbar()}

  padding: ${({ $hasHorizontalPadding }) =>
    $hasHorizontalPadding ? '13px 15px' : '13px 0'};
  display: ${({ $isHidden }) => ($isHidden ? 'none' : 'flex')};
  gap: 5px;
  overflow-x: auto;
  width: 100%;
  min-height: 44px;

  ${({ $hasBg }) =>
    $hasBg &&
    css`
      background-color: ${({ theme }) => theme.palette.primary.background};
    `}
`;

export const BreadcrumbsLabel = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.primary.labels};
  white-space: nowrap;
  user-select: none;

  @media (hover: hover) {
    &:hover {
      color: ${({ theme }) => theme.palette.brand.main};
    }
  }
`;

export const BreadcrumbsSkeleton = styled.div<{
  $hasHorizontalPadding?: boolean;
}>`
  display: flex;
  gap: 10px;
  padding: ${({ $hasHorizontalPadding }) =>
    $hasHorizontalPadding ? '13px 15px' : '13px 0'};
  background-color: ${({ theme }) => theme.palette.primary.background};
`;
